import React, { useEffect } from "react";
import Breadcrumb from "../Breadcrumb";
import Section from "../Section";
import AboutUsSection from "../Section/AboutSection";
import TeamSection from "../Section/TeamSection";
import TestimonialSection from "../Section/TestimonialSection";
import FranchiseForm from "./FranchiseForm";
import { pageTitle } from "../../helpers/PageTitle";
import {
  FaSolarPanel,
  FaIndustry,
  FaTools,
  FaChargingStation,
  FaSun,
  FaHandshake,
} from "react-icons/fa";
import "./AboutPage.css";
import FunfactSection from "../Section/FunfactSection";

const serviceData = [
  {
    icon: <FaSolarPanel />,
    title: "Solar EPC & Project Execution",
    subTitle:
      "End-to-end solar engineering, procurement, and construction ensuring smooth project execution from start to finish.",
  },
  {
    icon: <FaIndustry />,
    title: "Commercial & Industrial Solar Solutions",
    subTitle:
      "Custom solar power systems for industries and businesses, reducing electricity costs and carbon footprint.",
  },
  {
    icon: <FaTools />,
    title: "Solar Panel Cleaning & AMC Services",
    subTitle:
      "Professional maintenance, inspection, and cleaning services to ensure optimal solar panel performance.",
  },
  {
    icon: <FaChargingStation />,
    title: "E-Mobility & EV Charging Solutions",
    subTitle:
      "Smart EV charging stations for residential, commercial, and public spaces promoting green mobility.",
  },
];

const teamData = [
   {
    imgUrl: "https://i.ibb.co/N2Br24SG/Priyanka-Malik.jpg",
    name: "Priyanka Malik",
    designation: "HR Manager",
  },
  {
    imgUrl: "https://i.ibb.co/dJpQLdGV/Vijay-Roy.jpg",
    name: "Vijay Roy",
    designation: "Team Leader",
  },
  {
    imgUrl: "https://i.ibb.co/HTm2T440/Sanskar-Singh.jpg",
    name: "Sanskar Singh",
    designation: "Sales Manager",
  },
  // {
  //   imgUrl: "https://i.ibb.co/Z1gC27DM/Kajal-Singh.jpg",
  //   name: "Kajal Singh",
  //   designation: "Floor Support",
  // },
];
const funfactData = [
  {
    iconUrl: '/images/icons/funfact_icon_1.svg',
    funfactNumber: '1.8',
    title: 'Happy Clients',
  },
  {
    iconUrl: '/images/icons/funfact_icon_2.svg',
    funfactNumber: '2',
    title: 'Project Done',
  },
  {
    iconUrl: '/images/icons/funfact_icon_3.svg',
    funfactNumber: '1',
    title: 'Awards Win',
  },
  {
    iconUrl: '/images/icons/funfact_icon_4.svg',
    funfactNumber: '70000+',
    title: 'Profit Gain',
  },
];

  // {
  //   iconUrl: '/images/icons/funfact_icon_1.svg',
  //   funfactNumber: '1',
  //   title: 'Happy Clients',
  // },
  // {
  //   iconUrl: '/images/icons/funfact_icon_2.svg',
  //   funfactNumber: '2',
  //   title: 'Project Done',
  // },
  // {
  //   iconUrl: '/images/icons/funfact_icon_3.svg',
  //   funfactNumber: '7',
  //   title: 'Awards Win',
  // },
  // {
  //   iconUrl: '/images/icons/funfact_icon_4.svg',
  //   funfactNumber: '10',
  //   title: 'Profit Gain',
  // },

const testimonialData = [
  {
    imgUrl: "/images/avatar_1.png",
    rating: "4.9",
    desc: "Riyansh Solar transformed our factory’s energy setup. We’re saving up to 40% on power costs monthly!",
    name: "Ankit Verma",
    designation: "Industrial Client",
  },
  {
    imgUrl: "/images/avatar_2.png",
    rating: "4.8",
    desc: "Highly professional team and seamless solar installation experience. Truly satisfied with their service.",
    name: "Meera Singh",
    designation: "Residential Client",
  },
  {
    imgUrl: "/images/avatar_3.png",
    rating: "5",
    desc: "Their franchise program helped me start my solar business successfully with complete technical support.",
    name: "Rajesh Kumar",
    designation: "Franchise Partner",
  },
];

export default function AboutPage() {
  pageTitle("About Us");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Breadcrumb title="About Us" bgUrl="https://png.pngtree.com/thumb_back/fh260/background/20210814/pngtree-business-gradient-geometric-gray-square-abstract-simple-gray-background-image_759189.jpg" />

      {/* About Section */}
      <Section
        pt="135"
        ptLg="75"
        pb="140"
        pbLg="80"
        className="position-relative">
        {" "}
        <AboutUsSection
           thumbUrl="https://images.unsplash.com/photo-1466611653911-95081537e5b7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80"
          experienceBgUrl="https://t3.ftcdn.net/jpg/09/76/62/26/360_F_976622688_UP2HewCWKm7KkUjKNkN4EKP5Yp1krVsc.jpg"
            experienceIconUrl="/images/experience_icon.svg"
          experienceNumber="5"
          experienceTitle="Years of Excellence"
          sectionTitleUp="About Our Company"
          sectionTitle='Empowering India with <span className="text-accent">Clean Solar Energy Solutions</span>'
          sectionSubTitle="GreenPower Energies is a leading solar energy provider committed to sustainable development across India. With over two decades of expertise, we specialize in delivering reliable, efficient, and affordable solar power systems for homes, businesses, and industries. Our certified team ensures quality installations and comprehensive energy management."
          grothTitle="Customer Satisfaction Rate"
          grothPercentage="95"
          featureList={[
            {
              title: "Complete Solar Solutions",
              subTitle:
                "Grid-tied, Off-grid, Hybrid systems, Solar Water Heaters, Street Lighting, and Energy Storage Solutions",
            },
            {
              title: "Full Business Support System",
              subTitle:
                "Professional training, marketing materials, technical assistance, and ongoing operational guidance",
            },
          ]}
          btnText="Join Our Network"
          btnUrl="/business_franchise"
          videoBtnText="Why Riyansh Solar?"
          videoBtnUrl="https://www.youtube.com/embed/4O3rBrAFQ4E"
        />{" "}
      </Section>

      <Section pt="140" ptLg="80" pb="140" pbLg="80" className="cs_gray_bg">
        {" "}
        <FunfactSection
          sectionTitleUp="Our Achievements"
          sectionTitle="Leading India's Clean Energy Transformation"
          sectionSubTitle="Committed to delivering sustainable solar solutions with innovative technology and nationwide presence for a greener future."
          data={funfactData}
          imgUrl="https://images.unsplash.com/photo-1466611653911-95081537e5b7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2072&q=80"
          shapeImgUrl="https://images.unsplash.com/photo-1509391366360-2e959784a276?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=150&q=80"
        />{" "}
      </Section>

      {/* Team Section */}
      {/* <Section pt="120" pb="100">
        <TeamSection
          data={teamData}
          sectionTitle="Meet Our Experienced <br/>Leadership Team"
          sectionTitleUp="Meet the Experts"
        />
      </Section> */}

      {/* Testimonials */}
      <Section
        pt="100"
        pb="100"
        style={{
          backgroundImage: `url('https://images.unsplash.com/photo-1466611653911-95081537e5b7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}>
        <TestimonialSection
          sectionTitleUp="Client Testimonials"
          sectionTitle="Success Stories That Inspire"
          sectionSubTitle="Discover how our clients and franchise partners are achieving energy independence and business success with our solar solutions."
          data={testimonialData}
        />
      </Section>

      {/* Franchise Form */}
      <FranchiseForm />
    </>
  );
}
